import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import general from '../../../modulos/general';
import {graphql} from 'react-apollo';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  let urlSlcm = 'https://montserratslcm.com/api/cotizaciones/'

  return (
    // <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
    <tr className=''>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numCoti}</td>    
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td> 
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ordenCompraCliente?elemento.ordenCompraCliente:''}</td> 
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estadoCoti}</td>    
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
          background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observaciones}</td>    
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
            <a style={{color: 'black'}}
              // href={'images/cotizaciones/' + elemento.archivoRecibido}
              href={urlSlcm + elemento.archivoRecibido}
                target="_blank">
              {elemento.archivoRecibido}
            </a>
          </td>
   </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>
  )
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminTraslado2 extends React.Component { 
  state = {argsBuscCad: {}, 
    argsQuery: `{$match: {tipoCoti: 'Traslado', estadoCoti: 'Creada'}},
    {$project: {_id: 1, numCoti: 1, fechaCreate: 1, usuarioCreate: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, lugarEntrega: 1, observacionesAut: 1, usuarioAut: 1, fechaAut: 1, archivoRecibido: 1, 
      estadoCoti: 1, observaciones: 1, ciudad: 1, email: 1, telefono: 1, ordenCompraCliente: 1}}`
  }
  async componentDidUpdate (prevProps){
    console.log(this.props.argsBuscCad, prevProps.argsBuscCad)
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'tipoCoti': 'Traslado', 'estadoCoti': 'Creada'`

      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      let argsBuscCad = ""
      
      argsBuscCad = `{$match: {${argsBuscar}}}, {$sort: {fechaCreate: -1}}`
      
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, ${argsBuscCad}]`}
      console.log(argsBuscarIt)
      await this.props.allCotizacionRtesTras.refetch(argsBuscarIt)
    }
  }

  render(){
  let list = []
  console.log(this.props.allCotizacionRtesTras.allCotizacionRtes)
  if(this.props.allCotizacionRtesTras.allCotizacionRtes){
    this.props.allCotizacionRtesTras.refetch()
    list = this.props.allCotizacionRtesTras.allCotizacionRtes
    console.log(list)
  }
    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Traslado de productos para clientes" btnNuevo={"SI"} styles={this.props.styles} handleClick={this.props.handleClick} />
          
          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''> 
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Creada</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Solicitud</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '20%'}}>Cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}># Orden</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Estado</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '32%'}}>Observaciones</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Archivo cliente</th>
                </tr>
              </thead>
              <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
            </table>
            <p></p>
          </div>
        </List>

      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesTras',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Traslado', estadoCoti: 'Creada'}},
    {$project: {_id: 1, numCoti: 1, fechaCreate: 1, usuarioCreate: 1, ciudadFechaEnvio: 1, descrEmpresa: 1, nombreContacto: 1, cargoContacto: 1, ciudadContacto: 1,
	    mailContacto: 1, telContacto: 1, lugarEntrega: 1, observacionesAut: 1, usuarioAut: 1, fechaAut: 1, archivoRecibido: 1, 
      estadoCoti: 1, observaciones: 1, ciudad: 1, email: 1, telefono: 1, ordenCompraCliente: 1}}]`}}}
  }),


)(AdminTraslado2) 